import Vue from "vue";

export function listMerchantExpertApi(params, success) {
    let url = "/admin/web/expert/listMerchantExpert";
    Vue.prototype.alexPost(url, params, success);
}

export function deleteExpertApi(params, success) {
    let url = "/admin/web/expert/deleteExpert";
    Vue.prototype.alexPost(url, params, success);
}

export function pageAllExpertApi(params, success,complete) {
    let url = "/admin/web/expert/pageAllExpert";
    Vue.prototype.alexPost(url, params, success,null,complete);
}

export function updateIsShowIndexApi(params, success,complete) {
    let url = "/admin/web/expert/updateIsShowIndex";
    Vue.prototype.alexPost(url, params, success,null,complete);
}


